import React, { useEffect } from "react";

import AccountLayout from "layouts/AccountLayout";
import MetaTags from "components/MetaTags";
import { useUsers } from "hooks";

import LoginDetails from "./components/LoginDetails";
import Identities from "./components/Identities";
import BillingInfo from "./components/BillingInfo";
import EmailPreferences from "./components/EmailPreferences";
import DeleteAccount from "./components/DeleteAccount";

const Overview = () => {
  const { loadCurrentUser } = useUsers();

  useEffect(() => {
    loadCurrentUser();
  }, []);

  return (
    <>
      <AccountLayout title="Overview">
        <LoginDetails />
        <Identities />
        <BillingInfo />
        <EmailPreferences />
        <DeleteAccount />
      </AccountLayout>
      <MetaTags>
        <meta
          name="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous & more!"
        />
      </MetaTags>
    </>
  );
};

export default Overview;
